import React from "react"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
import { notify } from "react-notify-toast"
import { parseDate } from "../../Helper"
import ECECCheckForm from "./ECECCheckForm"

class ECECCheck extends React.Component {
  state = {
    ecec_filename: this.props.user.ecec_filename,
    ecec_issuing_state: this.props.user.ecec_issuing_state,
    ecec_url: this.props.user.ecec_url,
    ecec_expiry: parseDate(this.props.user.ecec_expiry),
    ecec_number: this.props.user.ecec_number,
    ecec_status: this.props.user.ecec_verification_status,
  }

  handleStateChange = (key, value) => {
    this.setState({ [key]: value })
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleDateChange = (date) => {
    this.setState({ ecec_expiry: date })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const fields = ["ecec_issuing_state", "ecec_number", "ecec_expiry"]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field)
      if (!input.reportValidity()) {
        errors = true
        break;
      }
    }

    if (errors) {
      notify.hide();
      notify.show("You are missing one or more field(s)!")
      errors = true
    }

    if (!errors) {
      this.props.updatePersonalDetails({ ...this.state })
    }
  }

  tabs = [
    {
      pathname: "/personalid",
      text: "Personal I.D.",
    },
    {
      pathname: "/visa",
      text: "Visa Details",
    },
    {
      pathname: "/policecheck",
      text: "Police Check (Opt.)",
    },
    {
      pathname: "/wwcc",
      text: "WWCC (Optional)",
      active: false,
    },
    {
      pathname: "/usiCheck",
      text: "USI Check (Opt.)",
    },
    {
      pathname: "/ececcheck",
      text: "First AID",
      active: true,
    },
  ]

  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Identification"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <ECECCheckForm
            handleStateChange={this.handleStateChange}
            handleFormFieldChange={this.handleFormFieldChange}
            handleDateChange={this.handleDateChange}
            state={this.state}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ECECCheck)
